/*
 * @Author: lihwang
 * @Date: 2023-04-28 11:51:00
 * @LastEditors: yusha
 * @LastEditTime: 2024-06-27 21:05:09
 * @Description: interceptors
 */
import md5 from 'crypto-js/md5';
import Cookies from 'js-cookie';
import { api } from '@/service';

import { processDifferentEnv } from '@/utils/tool/processDifferentEnv';
import { apiTag } from './interceptors';

// 登录环境
export type loginEnv = 'dev' | 'test' | 'pre' | 'prod' | 'prod1';
/**
 * 存在cookie的token名称
 */
export const TokenSignLocal: string =
	process.env.NODE_ENV === 'development'
		? 'development_route/token'
		: 'production_route/token';

export const SiteLocalKey =
	process.env.NODE_ENV === 'development'
		? 'development_route/site'
		: 'production_route/site';

/**
 * 存储cookie的环境
 */
// export const cookieEnv =
// 	process.env.NODE_ENV === 'production'
// 		? '.theckb.com'
// 		: window.location.hostname;

/** 平台 */
export const PlatLocalstorage: string =
	process.env.NODE_ENV === 'development'
		? 'development_route/plat'
		: 'production_route/plat';

const setSingCookie = (key: string, value: string, domainEnv: string) => {
	Cookies.set(key, value, {
		path: '/',
		domain: domainEnv,
		expires: 3
	});
};
/** 青蛙频道跳转设置cookie */
export const setCookies = (isLogin: boolean) => {
	const env = process.env.REACT_APP_ENV;
	const cookieTokenName = `${env}_route/token`;
	const cookiePlatName = `${env}_route/plat`;
	const cookieCurShopName = `${env}_route/curShop`;

	/** 设置cookie的域 */
	const domainEnv =
		process.env.NODE_ENV === 'development' ? 'localhost' : '.theckb.com';

	if (!isLogin) {
		Cookies.remove(cookieTokenName, {
			path: '/',
			domain: domainEnv
		});
		const parsePlat = JSON.parse(
			localStorage.getItem(PlatLocalstorage) ?? ''
		);
		setSingCookie(cookiePlatName, parsePlat.val, domainEnv);
		Cookies.remove(cookieCurShopName, {
			path: '/',
			domain: domainEnv
		});
		return;
	}

	const parseToken = JSON.parse(localStorage.getItem(TokenSignLocal) ?? '');
	const parsePlat = JSON.parse(localStorage.getItem(PlatLocalstorage) ?? '');
	const parseCurshop = JSON.parse(
		localStorage.getItem(ShopLocalstorage) ?? ''
	);
	setSingCookie(cookieTokenName, parseToken.val, domainEnv);
	setSingCookie(cookiePlatName, parsePlat.val, domainEnv);
	setSingCookie(cookieCurShopName, parseCurshop.val, domainEnv);
};

/** B2B/D2C 主题切换 */
export const togglePlat = (systemSource: number) => {
	const plat = systemSource === 1 ? 'D2C' : 'B2B';
	window.document.documentElement.setAttribute('data-theme', plat ?? 'D2C');
	localStorage.setItem(
		PlatLocalstorage,
		JSON.stringify({
			val: plat.toLocaleLowerCase()
		})
	);
};

/** 通过 cookie 设置信息 */
export const setLocalstorageToken = (token: string) => {
	localStorage.setItem(
		TokenSignLocal,
		JSON.stringify({
			val: token
		})
	);
};

export const ShopLocalstorage: string = window.location.port
	? 'development_route/curShop'
	: 'production_route/curShop';
export const setLocalstorageShopId = (id: string) => {
	localStorage.setItem(
		ShopLocalstorage,
		JSON.stringify({
			val: id
		})
	);
};

interface MockLogin {
	password: string;
	nameOrEmail: string;
}

export const getLoginToken = async ({ password, nameOrEmail }: MockLogin) => {
	logout();
	const loginRes = await api.customer.passwordLogin.passwordLogin({
		password: md5(password).toString(),
		nameOrEmail,
		platformType: 1
	});
	return loginRes.data?.token;
};

export const goToSignUp = () => {
	const envArr = window.location.hostname.split('s.theckb.com');
	const url = processDifferentEnv({
		test: () =>
			// `https://master-s.theckb.com/login_h5?from=${window.location.href}`,
			`https://${envArr[0]}s.theckb.com/signup_h5?from=ckbh5`,
		pre: () => `https://pre-s.theckb.com/signup_h5?from=ckbh5`,
		prod: () => `https://s.theckb.com/signup_h5?from=ckbh5`
	});
	window.location.href = url;
};

const getTokenSignCookie = () => {
	const hostArr = window.location.host.split('s.theckb.com');
	let env = 'test';
	if (!hostArr[0] && window.location.host.includes('s.theckb.com')) {
		env = 'prod';
	}
	if (hostArr[0] && hostArr[0].includes('pre')) {
		env = 'pre';
	}

	return env + '_route/token';
};

/** 退出清除信息 */
export const logout = () => {
	window.localStorage.removeItem(ShopLocalstorage);
	window.localStorage.removeItem(TokenSignLocal);
	if (process.env.NODE_ENV === 'production') {
		Cookies.remove(getTokenSignCookie(), {
			domain: '.theckb.com'
		});
	}
};
